export default __webpack_public_path__ + "assets/models/33d248659a404cbac195d35adac55996.glb";